/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { useEffect } from '@wordpress/element';
import memoize from 'memize';
import times from 'lodash/times';
import { compose } from '@wordpress/compose';
import { InnerBlocks } from '@wordpress/block-editor';
import { withDispatch, select } from '@wordpress/data';

/**
 * Inner dependencies.
 */
import Inspector from './inspector';
import { updateBlockStyle } from './inline-styles';

/**
 * Constants
 */
const ALLOWED_BLOCKS = [ 'gutenify/info-box' ];

/**
 * Returns the layouts configuration for a given number of feature items.
 *
 * @param {number} count Number of feature items.
 *
 * @return {Object[]} Columns layout configuration.
 */
const getCount = memoize( ( count ) => {
	return times( count, () => [ 'gutenify/info-box', {
		className: 'has-shadow-dark',
	} ] );
} );

const Edit = ( props ) => {
	const { attributes, isSelected, className } = props;
	const { layout, columnSize, hideButtons } = attributes;
	const wrapperClasses = classnames(
		className,
		`gutenify-admin-service-block-wrapper gutenify-service-${ layout }`,
		`gutenify-service-col-${ columnSize }`,
		hideButtons ? 'gutenify--service--hide-button' : ''
	);
	useEffect( () => {
		updateBlockStyle( {}, props );
	}, [] );
	return (
		<div className={ wrapperClasses }>

			{ isSelected && <Inspector { ...props } /> }
			<div className="gutenify-admin-service-block">
				<InnerBlocks
					allowedBlocks={ ALLOWED_BLOCKS }
					template={ getCount( 2 ) }
					templateInsertUpdatesSelection={ false }
					orientation={ 'horizontal' }
					// __experimentalCaptureToolbars={ true }
					renderAppender={ () => (
						<InnerBlocks.ButtonBlockAppender />
					) }
				/>
			</div>
		</div>
	);
};

export default compose( [
	withDispatch( ( dispatch, props ) => {
		const { clientId } = props;

		return {
			updateInnerBlocks( template ) {
				const children = select( 'core/block-editor' ).getBlocksByClientId( clientId )[ 0 ].innerBlocks;
				children.forEach( function( child ) {
					if ( 'gutenify/info-box' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, {
							layout: template.name,
							titleAlign: template.titleAlign,
							iconAlign: template.iconAlign,
							buttonAlign: template.buttonAlign,
						} );
						const grandChildren = select( 'core/block-editor' ).getBlocksByClientId( child.clientId )[ 0 ].innerBlocks;
						grandChildren.forEach( function( grandChild ) {
							if ( 'gutenify/icon' === grandChild.name ) {
								dispatch( 'core/block-editor' ).updateBlockAttributes( grandChild.clientId, { contentJustification: template.iconAlign } );
							}
							if ( 'core/heading' === grandChild.name ) {
								dispatch( 'core/block-editor' ).updateBlockAttributes( grandChild.clientId, { textAlign: template.titleAlign } );
							}
							if ( 'core/paragraph' === grandChild.name ) {
								dispatch( 'core/block-editor' ).updateBlockAttributes( grandChild.clientId, { align: template.titleAlign } );
							}
							if ( 'gutenify/buttons' === grandChild.name ) {
								dispatch( 'core/block-editor' ).updateBlockAttributes( grandChild.clientId, { contentJustification: template.buttonAlign } );
							}
						} );
					}
				} );
			},
		};
	} ),
] )( Edit );
